import { useTranslation } from "react-i18next";

export default function LocationStatus({ location, onRetry, wsConnected }) {
  const { t } = useTranslation();
  return (
    <div className="mt-4">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-1">{t("location.title")}</p>
      {location ? (
        <p className="text-xs text-gray-600 font-body">
          {location.latitude.toFixed(4)}, {location.longitude.toFixed(4)}
        </p>
      ) : (
        <div className="space-y-1.5">
          <p className="text-xs text-orange-600 font-body">{t("location.no_gps")}</p>
          <button
            onClick={onRetry}
            className="text-[10px] font-bold text-black underline underline-offset-2 font-body hover:text-gray-600"
            data-testid="retry-gps-btn"
          >
            {t("location.retry_gps")}
          </button>
          <p className="text-[10px] text-gray-400 font-body">{t("location.tap_to_set")}</p>
        </div>
      )}
      <div className="flex items-center gap-1.5 mt-2" data-testid="ws-status">
        <div className={`w-2 h-2 rounded-full ${wsConnected ? "bg-green-500" : "bg-gray-300"}`} />
        <span className="text-[10px] text-gray-400 font-body">
          {wsConnected ? t("location.live") : t("location.connecting")}
        </span>
      </div>
    </div>
  );
}
